import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import HotelIcon from "@mui/icons-material/Hotel";
import RepeatIcon from "@mui/icons-material/Repeat";
import Typography from "@mui/material/Typography";
import Job from "../../Assets/svg/Job";
// import
export default function CustomizedTimeline(props) {
  const item = props.item;

  return (
    <Timeline>
      {item?.professionalDetails?.map((item, index) => (
        <TimelineItem key={index}>
          <TimelineSeparator>
            <TimelineDot>
              <Job />
            </TimelineDot>
            {index + 1 !== item?.professionalDetails?.length && (
              <TimelineConnector />
            )}
          </TimelineSeparator>
          <TimelineContent sx={{ py: "12px", px: 2 }}>
            <Typography variant="h6" component="span" className="set-title">
              {item?.designation}
            </Typography>
            <Typography className="company">{item?.company}</Typography>
            <Typography className="date"> {item?.period}</Typography>
          </TimelineContent>
        </TimelineItem>
      ))}
      {/* <TimelineItem>
        <TimelineSeparator>
          <TimelineDot>
            <Job />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span" className="set-title">
            VP & Head of Design at Bharti Airtel Ltd.
          </Typography>
          <Typography className="company">Airtel Digital Ltd.</Typography>
          <Typography className="date">Jan 2019 - Mar 2023</Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot>
            <Job />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span" className="set-title">
            VP & Head of Design at Bharti Airtel Ltd.
          </Typography>
          <Typography className="company">Airtel Digital Ltd.</Typography>
          <Typography className="date">Jan 2019 - Mar 2023</Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot>
            <Job />
          </TimelineDot>
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span" className="set-title">
            VP & Head of Design at Bharti Airtel Ltd.
          </Typography>
          <Typography className="company">Airtel Digital Ltd.</Typography>
          <Typography className="date">Jan 2019 - Mar 2023</Typography>
        </TimelineContent>
      </TimelineItem> */}
    </Timeline>
  );
}
